import React from 'react';

import { SideNavRoute, Size } from '../../types';
import { renderRoutes } from './SideNav.helpers';
import { SideNavContainer } from './SideNav.styles';

export interface SectionRoute {
  sectionTitle: string;
  dataQaId?: string;
  size?: Size;
  routes: SideNavRoute[];
}

export type Routes = SideNavRoute[] | SectionRoute | SectionRoute[];

export interface SideNavProps {
  routes: Routes | any;
  dataQaId?: string;
}

const SideNav: React.FC<SideNavProps> = ({ routes, dataQaId }) => (
  <SideNavContainer data-qa-id={dataQaId}>{renderRoutes(routes)}</SideNavContainer>
);

export default SideNav;
